import { Users, CalendarClock, UserCheck, UserMinus } from 'lucide-react';
import { Card } from '@/shared/components/ui/Card';

interface HrStatCardsProps {
  totalStaff: number;
  pendingLeaves: number;
  onLeave: number;
  activeStaff: number;
}

const ICONS = { Users, CalendarClock, UserCheck, UserMinus };

function Stat({ icon, label, value }: { icon: keyof typeof ICONS; label: string; value: number }) {
  const Icon = ICONS[icon];
  return (
    <Card className="flex items-center gap-3 p-4">
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-container text-on-primary-container">
        <Icon className="h-5 w-5" />
      </div>
      <div className="min-w-0">
        <p className="text-display-sm font-semibold leading-none text-on-surface">{value}</p>
        <p className="mt-1 text-body-sm text-on-surface-variant">{label}</p>
      </div>
    </Card>
  );
}

export function HrStatCards({ totalStaff, pendingLeaves, onLeave, activeStaff }: HrStatCardsProps) {
  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
      <Stat icon="Users" label="Total Staff" value={totalStaff} />
      <Stat icon="CalendarClock" label="Pending Leaves" value={pendingLeaves} />
      <Stat icon="UserMinus" label="On Leave Today" value={onLeave} />
      <Stat icon="UserCheck" label="Active Staff" value={activeStaff} />
    </div>
  );
}
